// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3iG80","title":"Header_title__2qsjX","left":"Header_left__2Y5-Y","clinicName":"Header_clinicName__2bdmF"};